import { getInstance } from './instance';

const instance = getInstance();

export const getCustomerSubscription = () => {
  const url = '/subscriptions/find-one';

  try {
    return instance
      .get(url)
      .then((res) => res.data)
      .catch((error) => Promise.reject(error));
  } catch (e) {
    return Promise.reject(e);
  }
};

// Removes the member's scheduled cancellation; answers with the same body as find-one.
export const removeScheduledCancellation = () => {
  const url = '/subscriptions/remove-scheduled-cancellation';

  try {
    return instance
      .post(url)
      .then((res) => res.data)
      .catch((error) => Promise.reject(error));
  } catch (e) {
    return Promise.reject(e);
  }
};
